export default {
    LEVEL_ADMIN_GENERAL: 1,
    LEVEL_ADMIN_WHITELABEL: 2,
    LEVEL_ADMIN_CONDOMINIUM: 3,
    LEVEL_CONDOMINIUM_EMPLOYEE: 4,
    LEVEL_APP_USER: 7,
    LEVEL_ADDRESS_MANAGER: 8,
}